import { WebSocketMessageTypeIncoming } from "../../../Enums/WebSocketMessageTypeIncoming";
import { WsLogoStatus } from "./WsLogoStatus";

export class WsLogosStatus {
  Type: WebSocketMessageTypeIncoming;
  LogosStatus: Array<WsLogoStatus> = new Array<WsLogoStatus>();

  constructor() {
    this.Type = WebSocketMessageTypeIncoming.WsLogosStatus;
  }
}
